import React, { FC } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
import { Doughnut } from 'react-chartjs-2';
import { Container, Title, Chart } from './ChartDonut.styles';
import { greyScale } from '../../../../styles/newThemeVariables.styles';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CHART_OPTIONS = {
  cutout: '60%',
  label: 'percent',
  borderColor: greyScale.grey100,
  borderJoinStyle: 'miter' as const,
  borderAlign: 'inner' as const,
  borderWidth: 4,
  layout: {
    padding: {
      left: 75,
      right: 75,
    },
  },
  plugins: {
    datalabels: {
      labels: {
        value: {
          offset: 16,
          anchor: 'end' as const,
          align: 'end' as const,
          textAlign: 'center' as const,
          font: {
            size: 16,
            family: 'f37_jagger, Helvetica, sans-serif',
            lineHeight: 1.4,
          },
          formatter: function (value: number, ctx: Context) {
            return [
              `${ctx.chart.data.labels?.[ctx.dataIndex]}`,
              `${Math.round(value * 100) / 100}%`,
            ];
          },
        },
      },
    },
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
};

interface Color {
  value: string;
}

interface ChartDonutSegment {
  label: string;
  value: number;
  color: Color;
}

export interface ChartDonutProps {
  title?: string;
  segments?: Partial<ChartDonutSegment>[];
}

const ChartDonut: FC<ChartDonutProps> = ({ title, segments, ...props }) => {
  const labels = segments?.map(({ label }) => label);
  const values = segments?.map(({ value }) => value);
  const colors = segments?.map(({ color }) => color?.value);

  const chartData = {
    labels: labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
      },
    ],
  };

  return (
    <Container>
      {title && <Title>{title}</Title>}
      <Chart {...props}>
        <Doughnut data={chartData} options={CHART_OPTIONS} />
      </Chart>
    </Container>
  );
};

export default ChartDonut;
